import { get, post } from '../axios'

// 新增分类
export function collection_add_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/add`,
    map,
    option
  ).then(response => response)
}

// 分类列表
export function collection_listing_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/listing`,
    map,
    option
  ).then(response => response)
}

// 浏览spu
export function collection_browse_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/browse`,
    map,
    option
  ).then(response => response)
}

// 分类详情产品展示分页
export function collection_detail_product_more_collectionId_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/detail/product/more/${map.collectionId}`,
    map,
    option
  ).then(response => response)
}

// 分类-手动新增产品展示
export function collection_detail_product_show_add_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/detail/product_show/add`,
    map,
    option
  ).then(response => response)
}

// 分类-手动删除产品展示
export function collection_detail_product_show_delete_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/detail/product_show/delete`,
    map,
    option
  ).then(response => response)
}

// 分类详情-修改产品展示
export function collection_detail_product_show_modify_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/detail/product_show/modify`,
    map,
    option
  ).then(response => response)
}

// 分类详情
export function collection_detail_collectionId_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/detail/${map.collectionId}`,
    map,
    option
  ).then(response => response)
}

// 批量导入
export function collection_excelImport_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/excelImport`,
    map,
    option
  ).then(response => response)
}

// 关闭分类
export function collection_invalid_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/invalid`,
    map,
    option
  ).then(response => response)
}

// 修改分类
export function collection_modify_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/modify`,
    map,
    option
  ).then(response => response)
}

// 启用分类
export function collection_valid_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/valid`,
    map,
    option
  ).then(response => response)
}

// 分类-复制
export function collection_copy_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/copy`,
    map,
    option
  ).then(response => response)
}

// 删除分类
export function collection_delete_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/delete`,
    map,
    option
  ).then(response => response)
}

// 导出
export function collection_excelExport_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/excelExport`,
    map,
    option
  ).then(response => response)
}

// 自动-搜索商品tag或者Type
export function collection_queryProductTagOrType_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/queryProductTagOrType`,
    map,
    option
  ).then(response => response)
}

// 预览
export function collection_preview_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/preview`,
    map,
    option
  ).then(response => response)
}

// 分类-自动-编辑产品展示
export function collection_detail_product_auto_show_modify_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/detail/product_auto_show/modify`,
    map,
    option
  ).then(response => response)
}

// 分类-自动-删除产品展示
export function collection_detail_product_auto_show_delete_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/detail/product_auto_show/delete`,
    map,
    option
  ).then(response => response)
}

// 导出
export function collection_collectionProductsExport_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/collectionProductsExport`,
    map,
    option
  ).then(response => response)
}

// 导出校验
export function collection_invalidExport_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/invalidExport`,
    map,
    option
  ).then(response => response)
}

// 分类列表
export function collect_listing_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/listing`,
    map,
    option
  ).then(response => response)
}

// 新增分类
export function collect_add_post(map, option) {
  return post(`${process.env.VUE_APP_COLLECT}/collect/add`, map, option).then(
    response => response
  )
}

// 关闭分类
export function collect_invalid_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/invalid`,
    map,
    option
  ).then(response => response)
}

// 启用分类
export function collect_valid_post(map, option) {
  return post(`${process.env.VUE_APP_COLLECT}/collect/valid`, map, option).then(
    response => response
  )
}

// 删除分类
export function collect_delete_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/delete`,
    map,
    option
  ).then(response => response)
}

// 修改分类
export function collect_modify_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/modify`,
    map,
    option
  ).then(response => response)
}

// 预览
export function collect_preview_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/preview`,
    map,
    option
  ).then(response => response)
}

// 分类详情产品展示分页
export function collect_detail_product_more_collectId_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/detail/product/more/${map.collectId}`,
    map,
    option
  ).then(response => response)
}

// 分类-自动-编辑产品展示
export function collect_detail_product_auto_show_modify_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/detail/product_auto_show/modify`,
    map,
    option
  ).then(response => response)
}

// 分类-自动-删除产品展示
export function collect_detail_product_auto_show_delete_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/detail/product_auto_show/delete`,
    map,
    option
  ).then(response => response)
}

// 根据站点获取语言
export function collect_getLang_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/getLang`,
    map,
    option
  ).then(response => response)
}

// 导出
export function collect_excelExport_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/excelExport`,
    map,
    option
  ).then(response => response)
}

// 分类详情
export function collect_detail_collectId_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/detail/${map.collectId}`,
    map,
    option
  ).then(response => response)
}

// 手动预览
export function collect_browseSpu_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/browseSpu`,
    map,
    option
  ).then(response => response)
}

// 分类-手动删除产品展示
export function collect_detail_product_show_delete_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/detail/product_show/delete`,
    map,
    option
  ).then(response => response)
}

// 分类-手动新增产品展示
export function collect_detail_product_show_add_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/detail/product_show/add`,
    map,
    option
  ).then(response => response)
}

// 分类详情-修改产品展示
export function collect_detail_product_show_modify_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/detail/product_show/modify`,
    map,
    option
  ).then(response => response)
}

// 自动-手动维护预览
export function collect_browseAutoSpu_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/browseAutoSpu`,
    map,
    option
  ).then(response => response)
}

// 切换分类类型
export function collect_switchType_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/switchType`,
    map,
    option
  ).then(response => response)
}

// 自动-搜索商品tag或者Type
export function collect_queryProductTagOrType_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/queryProductTagOrType`,
    map,
    option
  ).then(response => response)
}

// 批量导入
export function collect_excelImport_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/excelImport`,
    map,
    option
  ).then(response => response)
}

// 分类日志
export function collect_log_collectId_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/log/${map.collectId}`,
    map,
    option
  ).then(response => response)
}

// autoManualInit
export function collect_autoManualInit_get(map, option) {
  return get(
    `${process.env.VUE_APP_COLLECT}/collect/autoManualInit`,
    map,
    option
  ).then(response => response)
}

// 浏览spu
export function collect_browse_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/browse`,
    map,
    option
  ).then(response => response)
}

// 分类-复制
export function collect_copy_post(map, option) {
  return post(`${process.env.VUE_APP_COLLECT}/collect/copy`, map, option).then(
    response => response
  )
}

// 分类详情
export function collect_mixmatch_detail_collectId_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/mixmatch/detail/${map.collectId}`,
    map,
    option
  ).then(response => response)
}

// 推送shopify
export function collect_pushShopify_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECT}/collect/pushShopify`,
    map,
    option
  ).then(response => response)
}
